import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import './VerificarCertificado.css';

const supabaseUrl = 'https://yehzsmvmeaxteqjdqixe.supabase.co';
const supabaseKey = 'sb_publishable_uciWrgaTw41dTL2mIT8XHw_uML1TT7w';
const supabase = createClient(supabaseUrl, supabaseKey);

const VerificarCertificado = () => {
    const [nombre, setNombre] = useState('');
    const [resultado, setResultado] = useState(null);
    const [errorMensaje, setErrorMensaje] = useState(null);

    const buscarCertificado = async () => {
        setErrorMensaje(null);
        setResultado(null);

        if (!nombre.trim()) {
            setErrorMensaje("Por favor, ingrese su Nombre Completo.");
            return;
        }

        const { data, error } = await supabase
            .from('igccertificados') // Asegúrate de que esta sea la tabla correcta para escuela
            .select('*')
            .ilike('apellidos_nombres', `%${nombre}%`);

        if (error) { 
            setErrorMensaje("Error de conexión, intente más tarde.");
            return; 
        }

        if (!data || data.length === 0) {
            setResultado('no-encontrado');
        } else if (data.length > 1) {
            setErrorMensaje("Se encontraron múltiples resultados. Por favor, sea más específico.");
        } else {
            setResultado(data[0]);
        }
    };

    return (
        <section className="container">
            <div id="main-layout">
                <div className="card search-card">
                    <h2>Verificar Certificado</h2>
                    <div className="input-group">
                        <input 
                            type="text" 
                            value={nombre} 
                            onChange={(e) => setNombre(e.target.value)} 
                            placeholder="Ingrese nombre completo" 
                            style={errorMensaje ? { borderColor: '#dc2626' } : {}}
                        />
                        {errorMensaje && (
                            <p style={{ color: '#dc2626', fontSize: '0.85rem', marginTop: '5px', fontWeight: 'bold' }}>
                                {errorMensaje}
                            </p>
                        )}
                    </div>
                    <button id="btn-buscar" onClick={buscarCertificado}>Consultar</button>
                </div>
                
                <div id="result-container" className="result-visible">
                    {resultado === 'no-encontrado' && (
                        <div className="result-card error-card">
                            <div className="error-header">NO ENCONTRADO</div>
                            <div className="result-body" style={{ textAlign: 'center' }}>
                                <h3 className="student-name" style={{color: '#991b1b'}}>NO REGISTRADO</h3>
                                <p>El nombre no coincide con ningún certificado en nuestro sistema.</p>
                            </div>
                        </div>
                    )}

                    {resultado && resultado !== 'no-encontrado' && (
                        <div className="result-card">
                            <div className="result-header"><span className="status-tag">Certificado Verificado ✓</span></div>
                            <div className="result-body">
                                <h3 className="student-name">{resultado.apellidos_nombres}</h3>
                                <div className="info-list">
                                    <p><strong>DNI:</strong> <span>{resultado.dni}</span></p>
                                    <p><strong>Curso:</strong> <span>{resultado.curso}</span></p>
                                    <p><strong>Nota:</strong> <span style={{color: '#10b981', fontWeight: 'bold'}}>Aprobada</span></p>
                                </div>
                                <div className="footer-note">
                                    {resultado.url_pdf ? 
                                        <a href={resultado.url_pdf} target="_blank" rel="noreferrer" className="download-btn">📄 Descargar Certificado</a> : 
                                        "* El archivo digital del certificado se habilitará próximamente."
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};
export default VerificarCertificado;